<div *ngIf="!displayShortNavigation">
  <div class="menuItem sidebar" (click)="redirectTo('tabProjectstd')" [ngClass]="{'active': selectedTab === activeTab.Projects}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Project_icon.svg' class="menu-navigation-icon"
                title="{{'projectValuation.projects' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectValuation.projects' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="redirectTo('tabValuationPortfolio')" [ngClass]="{'active': selectedTab === activeTab.ValPortofolios}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Val_Portfolios_icon.svg' class="menu-navigation-icon"
                title="{{'projectValuation.valuationPortfolios' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectValuation.valuationPortfolios' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="!reportInactive && redirectTo('tabReport')"
       [ngClass]="{'active': selectedTab === activeTab.Dashboards, 'disabled': reportInactive}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Dashboard_icon.svg' class="menu-navigation-icon"
                title="{{'projectValuation.reports' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectValuation.reports' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="!propertyInactive && redirectTo('tabProperty')"
       [ngClass]="{'active': selectedTab === activeTab.Properties, 'disabled': propertyInactive}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Properties_icon.svg' class="menu-navigation-icon"
                title="{{'projectValuation.properties' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectValuation.properties' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="!tenantInactive && redirectTo('tabTenant')"
       [ngClass]="{'active': selectedTab === activeTab.Tenant, 'disabled': tenantInactive}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Tenant_icon_solid.svg' class="menu-navigation-icon"
                title="{{'projectValuation.tenant' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectValuation.tenant' | translate | uppercase}}</div>
  </div>
  <div class="menuItem sidebar" (click)="!valuationInactive && redirectTo('tabValuation')"
       [ngClass]="{'active': selectedTab === activeTab.Valuations, 'disabled': valuationInactive}">
    <div class="sidebar-icon-container">
      <svg-icon src='./assets/icons/Valuations_icon_solid.svg' class="menu-navigation-icon"
                title="{{'projectValuation.valuations' | translate | uppercase}}" align='center'></svg-icon>
    </div>
    <div class="menu-navigation-title">{{'projectValuation.valuations' | translate | uppercase}}</div>
  </div>
</div>
